import { useEffect } from "react";
import { useSelector } from "react-redux";
import thankYouCody from "../../../../assets/images/cody.png";
import Button from "../../../../common/button";
const StepFinish = ({
  setBackButton,
  setFinishButton,
  payment,
  selectLand,
  setSuccessPayment,
}) => {
  const apiResponse = useSelector((state) => state?.checkout?.apiResponse);

  useEffect(() => {
    setBackButton(false);
    setFinishButton(false);
    setSuccessPayment(false);
  }, []);

  const handleButtonClick = () => {
    const redirectUrl = "/wizard";
    window.location.href = redirectUrl;
  };

  return (
    <>
      {apiResponse?.success === true && payment === "CREDITCARD" ? (
        <div className={"text-center"} style={{ minHeight: "500px" }}>
          <div className="flex flex-col sm:flex-row justify-evenly  ">
            <div>
              <img src={thankYouCody} alt="thankYouCody" />
            </div>
            <div className="flex flex-col justify-center  gap-3 4 text-left p-3 sm:p-0 text-white font-general">
              <h2 className="text-white text-center">
                Thank you and congratulations: <br /> you’re now a{" "}
                <span className="text-[#54ECB6]">Coderblock Landowner</span>!
              </h2>
              <p className="font-general text-xl text-white">
                You just got{" "}
                <span className="text-[#54ECB6]">{selectLand.length}</span>{" "}
                lands!
              </p>
              <div className="flex flex-col gap-1 mb-3">
                <p className="text-white font-general m-0">
                  These are your coordinates:
                </p>
                {selectLand && selectLand?.length > 0 ? (
                  <div>
                    {selectLand.map((land, index) => (
                      <span key={index}>
                        (<span className="text-[#54ECB6]">{land.x}</span>,{" "}
                        <span className="text-[#54ECB6]">{land.y}</span>)
                        {index < selectLand.length - 1 && ","}{" "}
                      </span>
                    ))}
                  </div>
                ) : null}
              </div>
              <p className="font-general text-lg text-white">
                You will soon receive an email with all the <br /> details about
                your lands and some interesting <br /> suggestions on how to get
                the most out of them.
              </p>
            </div>
          </div>
        </div>
      ) : apiResponse?.success === true ? (
        <div className={"text-center"} style={{ minHeight: "500px" }}>
          <div className="flex flex-col sm:flex-row justify-evenly  ">
            <div>
              <img src={thankYouCody} alt="thankYouCody" />
            </div>
            <div className="flex flex-col justify-center  gap-3 4 text-left p-3 sm:p-0 text-white font-general">
              <h2 className="text-white">
                Thank you and congratulations: <br /> you’re now a{" "}
                <span className="text-[#54ECB6]">Coderblock Landowner</span>!
              </h2>
              <p className="font-general text-xl text-white">
                You just got{" "}
                <span className="text-[#54ECB6]">{selectLand.length}</span>{" "}
                lands!
              </p>
              <div className="flex flex-col gap-1 mb-3">
                <p className="text-white font-general m-0">
                  These are your coordinates:
                </p>
                {selectLand && selectLand?.length > 0 ? (
                  <div>
                    {selectLand.map((land, index) => (
                      <span key={index}>
                        (<span className="text-[#54ECB6]">{land.x}</span>,{" "}
                        <span className="text-[#54ECB6]">{land.y}</span>)
                        {index < selectLand.length - 1 && ","}{" "}
                      </span>
                    ))}
                  </div>
                ) : null}
              </div>
              <p className="font-general text-lg text-white">
                You will soon receive an email with all the <br /> details about
                your lands and some interesting <br /> suggestions on how to get
                the most out of them.
              </p>
              <p className="font-general text-lg text-white">
                Please notice that, due to network loads on the blockchain,{" "}
                <br />
                your land could be assigned with a 5-30 minutes delay.
              </p>
            </div>
          </div>
        </div>
      ) : apiResponse?.success === false ? (
        <div className={"text-center"} style={{ minHeight: "500px" }}>
          <div className="flex flex-col sm:flex-row justify-evenly  ">
            {/* <div>
            <img src={thankYouCody} alt="thankYouCody" />
          </div> */}
            <div className="flex flex-col justify-center  gap-3 4 text-left p-3 sm:p-0 text-white font-general">
              <h4 className="text-white">
                There was an error with your request. A refund will be issued on
                your account.
              </h4>
            </div>
          </div>
          <div className="text-center">
            <div>
              <Button
                className="mt-4 mx-auto p-2"
                variant="mint"
                onClick={handleButtonClick}
              >
                Wizard
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div className={"text-center"} style={{ minHeight: "500px" }}>
          <div className="flex flex-col sm:flex-row justify-evenly  ">
            <div className="flex flex-col justify-center  gap-3 4 text-left p-3 sm:p-0 text-white font-general">
              <h4 className="text-white">Loading ...</h4>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StepFinish;
